<h2 mat-dialog-title>{{ data.title ?? '' }}</h2>
<mat-dialog-content class="mat-typography">
  {{ data.description ?? '' }}
  @if (displayLoadingSpinner) {
    <app-spinner size="medium"></app-spinner>
  }
</mat-dialog-content>
@if (displayConfirmButton) {
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmLabel ?? ('COMMON.OK' | translate) }}</button>
  </mat-dialog-actions>
}
